import React from "react";
import { UncontrolledTooltip } from "reactstrap";

const PricingPreview = ({target, pricePerUnit}) => {
    let tiers = [];

    let normalized = pricePerUnit;
    if (typeof normalized === "string") {
        try {
            normalized = JSON.parse(normalized);
        } catch (e) {
            normalized = null;
        }
    }

    if (normalized && typeof normalized === "object") {
        if (Array.isArray(normalized)) {
            tiers = normalized;
        } else {
            const orderedKeys = Object.keys(normalized).sort((a, b) => Number(a) - Number(b));
            tiers = orderedKeys.map((key) => normalized[key]);
        }
    }

    return (
        <UncontrolledTooltip placement="top" trigger="hover" target={target}>
            {tiers && tiers.length > 0
                ? tiers.map((tier, index) => (
                    <div key={index}>
                        {(tier && tier.title ? tier.title : "") + (tier && tier.price ? `: ${tier.price}` : "")}
                    </div>
                ))
                : (typeof pricePerUnit === "string" ? pricePerUnit : "")}
        </UncontrolledTooltip>
    );
}

export default PricingPreview;